import { render, staticRenderFns } from "./image-info.html?vue&type=template&id=3069671e&scoped=true&external"
import script from "./image-info.js?vue&type=script&lang=js&external"
export * from "./image-info.js?vue&type=script&lang=js&external"
import style0 from "./image-info.scss?vue&type=style&index=0&id=3069671e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3069671e",
  null
  
)

export default component.exports